/**
 * Checks whether a value is an HTTPS URL string.
 *
 * @param {string | File | undefined} url The value to inspect.
 * @returns {boolean} True when the value starts with `https`.
 */
export const isHttps = (url?: string | File): boolean => {
  if (!url || typeof url !== "string") {
    return false;
  }

  return url.startsWith("https");
};
